import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'app-terms-of-service',
  templateUrl: './terms-of-service.component.html',
  styleUrls: ['./terms-of-service.component.css']
})
export class TermsOfServiceComponent implements OnInit, AfterViewInit {
  @Input() termVisible: boolean;

  constructor(private title: Title,private meta: Meta,private router: Router) { }

  ngOnInit() {
    this.title.setTitle('Terms of Service | Honest Gorilla');
    this.meta.updateTag({name: 'keywords', content: 'honest gorilla,terms of service,legal,terms,conditions'});
    this.meta.updateTag({name: 'description', content: 'The Honest Gorilla Terms of Service contains legal information about our company and how you may use our site to purchase products and services through Honest Gorilla.'});
    this.meta.updateTag({name: 'author', content: 'HonestGorilla'});
    this.meta.updateTag({name: 'robots', content: 'index, follow'});
  }
  ngAfterViewInit(): void {
    $('.navbar-toggler').click(function () {
      $('.navbar').toggleClass('parent');
    });
  }

  gotoMain(){
     
    this.router.navigate([window.open('https://www.honestgorilla.com/', '_blank')]);
  }
  mailMe (mail) // <--- element on which you need to apply click
    {
        mail = document.createElement("a");
        mail.href = "mailto:hello@honestgorilla.com?subject=Question&body=Hi";
        mail.click();
    }
}
